import axios, {AxiosError, AxiosInstance} from 'axios';
import { toast } from 'react-toastify';

let theApi:AxiosInstance;
let errorForReloadShowed=false;

export const handleApiError = (error: AxiosError): Promise<never> => {
    if(error.response?.status === 429 || error.response?.status === 404) {
        // Rate-limit and not-found errors are handled by their callers.
    } else if (error.response?.status && error.response.status >= 400 && error.response.status < 500) {
        toast.error('Some error happened, please consider reloading the page');
    } else {
        // Never auto-reload: a transient 5xx or network error must not silently
        // disconnect an active therapy session.
        const isLiveSession = document.location.href.includes('/session-')
            || document.location.href.includes('/csession-');

        if(!errorForReloadShowed) {
            errorForReloadShowed = true;
            const message = isLiveSession
                ? "Oops! A connection error occurred. Your session is still active - please check your connection. Reloading now would disconnect you."
                : "Oops! An error occurred.";

            toast.error(message, {
                autoClose: false,
                closeOnClick: false,
                onClose: () => {
                    errorForReloadShowed = false;
                },
            });

            if (!isLiveSession) {
                toast.info("If the problem persists, reload the page.", {
                    autoClose: false,
                });
            }
        }
    }

    return Promise.reject(error);
};

export const reloadApiConfig = (token:string) => {
    const config = {
        baseURL: process.env.REACT_APP_API_URL,
        //15 minutes timeout
        timeout: 15*60*1000,
        headers: {
            ...(token && { Authorization: `Bearer ${token}` }),
        },
    }
    theApi = axios.create(config);
    theApi.interceptors.response.use(
        response => {
            return response;
        },
        handleApiError,
    );
    return theApi;
}


theApi = reloadApiConfig(localStorage.getItem('tok')??"");

const api = () => {
    return theApi;
}


export default api;
